import { RealTimeAction } from '@/_core/fluxstore/types';
import { useSendCommand } from '@/_core/cqrs/use';
import { StorymapState } from '../../types';
import { useStorymapStore } from '../../useModule';
import { ChangeCardEstimation as ChangeCardEstimationCommand } from '@/api/storymapCardDetails/commands';
import { FlashJustDragged } from '../moveCard/flashJustDragged';

const { registerReducer, registerMiddleware, dispatch } = useStorymapStore();

export class ChangeCardEstimation extends RealTimeAction<StorymapState> {
    public static ACTION_TYPE = 'ChangeCardEstimation';

    public constructor(public id: string, public estimation: number, public isDispatchedByDetailsModal: boolean = false) {
        super(ChangeCardEstimation.ACTION_TYPE);
    }
}

const middleware = async (state: StorymapState, action: ChangeCardEstimation): Promise<boolean> => {
    if (action.isDispatchedByDetailsModal) {
        return true;
    }

    const subtask = state.subtasks.find((x) => x.id === action.id);

    const command = await ChangeCardEstimationCommand.create(subtask.id, subtask.title, state.id, action.estimation);

    useSendCommand(action, {
        createCommand: () => command,
    });

    return true;
};

const reducer = (state: StorymapState, action: ChangeCardEstimation): void => {
    const subtask = state.subtasks.find((x) => x.id === action.id);

    subtask.estimation = action.estimation;
    subtask.lastUpdatedAt = new Date();

    if (!action.isDispatchedByRealTimeCallback) {
        dispatch(new FlashJustDragged());
    }
};

//@ts-ignore
registerMiddleware(ChangeCardEstimation.ACTION_TYPE, middleware);

//@ts-ignore
registerReducer(ChangeCardEstimation.ACTION_TYPE, reducer);
